import cn from 'classnames';
import { useContext } from 'react';

import DefaultLink from 'components/common/DefaultLink';
import Text from 'components/common/Text';
import Logo from 'components/signUpFunnel/Logo';
import { BrandContext } from 'context/BrandContext';
import { brandData } from 'helpers/BrandData';
import styles from 'styles/components/footer/DesktopFooter';

const DesktopFooter = () => {
  const { brand } = useContext(BrandContext);

  const data = brandData(brand);
  const currentYear = new Date().getFullYear();

  if (!brand) return null;

  return (
    <div
      className={cn(
        styles.footer,
        'mx-auto flex w-full flex-row-reverse justify-start pl-8 pr-24 pt-16'
      )}
    >
      <div className="ml-auto text-right">
        <Text>Customer Support</Text>
        <Text>Mon - Fri 9AM - 6PM CT</Text>
        <Text>{data.supportPhoneNumber}</Text>
        <DefaultLink isExternal to={data.supportUrl} target="_blank" className="p-0 text-right">
          Contact Us
        </DefaultLink>
      </div>
      <div className={cn(styles.companyDetailsContainer)}>
        <Logo />
        <Text className="mt-8">©2013 - {currentYear}, Relish Labs LLC</Text>
      </div>
    </div>
  );
};

export default DesktopFooter;
